import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import translation_en from './translations/en/translationEN.json'
import translation_cz from './translations/cz/translationCZ.json'
import translation_hu from './translations/hu/translationHU.json'
import translation_ro from './translations/ro/translationRO.json'
import translation_ru from './translations/ru/translationRU.json'
import translation_sk from './translations/sk/translationSK.json'


const resources = {
    en: {
        translation_en,
        trans: translation_en,
    },
    cz: {
        translation_cz,
        trans: translation_cz,
    },
    hu: {
        translation_cz,
        trans: translation_hu,
    },
    ro: {
        translation_ro,
        trans: translation_ro,
    },
    ru: {
        translation_ru,
        trans: translation_ru,
    },
    sk: {
        translation_sk,
        trans: translation_sk,
    },
}

i18n
    .use(initReactI18next)
    .init({
        interpolation: { escapeValue: false },
        fallbackLng: 'en',
        debug: false,
        resources,
    });

export default i18n
